import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import HouseNumberlist from "../HouseNumberlist";

function AdminHouseNumber(){
    const[searchUi,setSearchUi]=useState(true)
    const[searchContent,setSearchContent]=useState('')
    
    return(

        <DataContext.Provider value={{searchUi,setSearchUi,searchContent,setSearchContent}}>
        <Navbar 
         navId={6}
        childrenPage={<HouseNumberlist/>}/>
        </DataContext.Provider>
    )
}

export default AdminHouseNumber;